import { Transition, TransitionChild } from "@headlessui/react";
import { PlainButton } from "@jugl-web/ui-kit";
import { FC, Fragment, ReactNode } from "react";

export interface SidebarOverlayProps {
  children: ReactNode;
  isOpen: boolean;
  closeLabel: string;
  onClose: () => void;
}

export const SidebarOverlay: FC<SidebarOverlayProps> = ({
  children,
  isOpen,
  closeLabel,
  onClose,
}) => (
  <Transition show={isOpen} as={Fragment}>
    <div className="contents">
      <TransitionChild
        as={Fragment}
        enter="transition-opacity duration-200"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity duration-200"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <PlainButton
          className="fixed inset-0 top-[48px] z-30 bg-black/50"
          aria-label={closeLabel}
          onClick={onClose}
        />
      </TransitionChild>
      <TransitionChild
        as={Fragment}
        enter="transition-transform duration-200"
        enterFrom="-translate-x-full"
        enterTo="translate-x-0"
        leave="transition-transform duration-200"
        leaveFrom="translate-x-0"
        leaveTo="-translate-x-full"
      >
        <div className="fixed top-[48px] left-0 z-40 h-[calc(100%-48px)]">
          {children}
        </div>
      </TransitionChild>
    </div>
  </Transition>
);
